/**
 * Diagnosis and Management Data Points
 * Category: Diagnosis
 */

export const diagnosisDataPoints = [
  // Diagnosis
  {
    id: 'diagnosis',
    label: 'DIAGNOSIS',
    category: 'Diagnosis',
    subcategory: 'Diagnosis',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'text',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter diagnosis...',
      helpText: 'Primary diagnosis for the patient'
    },
    code: '439401001', // SNOMED CT - Diagnosis
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Management Plan
  {
    id: 'management_plan',
    label: 'MANAGEMENT PLAN',
    category: 'Diagnosis',
    subcategory: 'Management Plan',
    fieldType: 'multi',
    isActive: true,
    options: ['Analgaesia', 'NEBS', 'IVF', 'Backslab', 'Stitches', 'Ventilate', 'Intube'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Select management interventions'
    },
    code: '182836005', // SNOMED CT - Treatment plan
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Disposition - Admit
  {
    id: 'admit',
    label: 'Admit',
    category: 'Diagnosis',
    subcategory: 'Disposition',
    fieldType: 'multi',
    isActive: true,
    options: ['ICU', 'Ward'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Admission requirements'
    },
    code: '32485007', // SNOMED CT - Hospital admission
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Disposition - Follow up
  {
    id: 'follow_up',
    label: 'Follow up',
    category: 'Diagnosis',
    subcategory: 'Disposition',
    fieldType: 'multi',
    isActive: true,
    options: ['None needed', 'As needed', 'Wound check 2 days'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Follow-up care requirements'
    },
    code: '390906007', // SNOMED CT - Follow-up encounter
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Follow up Date
  {
    id: 'follow_up_date',
    label: 'Date',
    category: 'Diagnosis',
    subcategory: 'Disposition',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'text',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter follow-up date...',
      helpText: 'Specific follow-up date if required'
    },
    code: '390906007', // SNOMED CT - Follow-up encounter
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Disposition - Further review
  {
    id: 'further_review',
    label: 'Further review',
    category: 'Diagnosis',
    subcategory: 'Disposition',
    fieldType: 'multi',
    isActive: true,
    options: ['None needed', 'If worse/worried', 'GP', 'Specialist'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Further review requirements'
    },
    code: '390906007', // SNOMED CT - Follow-up encounter
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Discharge advice sheet
  {
    id: 'discharge_advice_sheet',
    label: 'Discharge advice sheet given to patients, including counselling and red flags',
    category: 'Diagnosis',
    subcategory: 'Discharge Planning',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Confirmation of discharge advice provision'
    },
    code: '182836005', // SNOMED CT - Patient education
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Return advice
  {
    id: 'return_advice',
    label:
      'Advised to return if symptoms worsen, do not improve with treatment or new symptoms develop or if patient is worried',
    category: 'Diagnosis',
    subcategory: 'Discharge Planning',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Confirmation of return instructions given'
    },
    code: '182836005', // SNOMED CT - Patient education
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default diagnosisDataPoints
